<script context="module" lang="ts">
	export const defaultPaymentInfo = () => {
		return {
			totalCount: 0,
			totalAmount: 0,
			totalTaxablePrice: 0,
			totalReceivedTax: 0,
		};
	};

	export type PaymentInfo = {
		totalCount: number;
		totalAmount: number;
		totalTaxablePrice: number;
		totalReceivedTax: number;
	};

	export type PaymentTypeReportProps = {
		card: PaymentInfo;
		cash: PaymentInfo;
	};

</script>

<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui/src";
	//Utils
	import { formatKrwNumber } from "@hitit/hub/src/v7/utils";
	//Types
	//Props
	export let card: PaymentInfo;
	export let cash: PaymentInfo;
	//Constants
	//Variables
	//Functions
	//Do

</script>

<Card noPadding>
	<div class="container" t-id="payment-type-report">
		<div class="box card">
			<div class="img-title-qt">
				<img src="/img/icons/cash.png" alt="Card" />
				<p class="title-qt">카드 결제</p>
			</div>
			<div class="total-amount">{formatKrwNumber(card.totalAmount)}원</div>
			<div class="tax-value taxable-price">
				<span class="label">과세합계</span>
				<span class="price">{formatKrwNumber(card.totalTaxablePrice)}원</span>
			</div>
			<div class="tax-value received-tax">
				<span class="label">부가세</span>
				<span class="price">{formatKrwNumber(card.totalReceivedTax)}원</span>
			</div>
		</div>
		<div class="seperate" />
		<div class="box cash">
			<div class="img-title-qt">
				<img src="/img/icons/card.png" alt="Cash" />
				<p class="title-qt">현금 결제</p>
			</div>
			<div class="total-amount">{formatKrwNumber(cash.totalAmount)}원</div>
			<div class="tax-value taxable-price">
				<span class="label">과세합계</span>
				<span class="price">{formatKrwNumber(cash.totalTaxablePrice)}원</span>
			</div>
			<div class="tax-value received-tax">
				<span class="label">부가세</span>
				<span class="price">{formatKrwNumber(cash.totalReceivedTax)}원</span>
			</div>
		</div>
	</div>
</Card>

<style lang="scss">
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding: 20px 10px;
		box-sizing: border-box;
		.box {
			display: flex;
			flex-direction: column;
			gap: 10px;
			&.card {
				img {
					width: 42.2px;
					height: 30px;
				}
			}
			&.cash {
				img {
					width: 58.2px;
					height: 30px;
				}
			}
			.img-title-qt {
				display: flex;
				align-items: center;
				gap: 10.5px;
				img {
					object-fit: contain;
				}

				p.title-qt {
					font-weight: 550;
					color: #6d6f76;
				}
			}

			.total-amount {
				font-weight: 600;
				color: #46474b;
				font-size: 2rem;
			}
			.tax-value {
				display: flex;
				justify-content: space-between;
				color: #46474b;
			}
		}
		.seperate {
			width: 100%;
			height: 1px;
			background-color: #e6e7ec;
		}
	}

</style>
